import { PropsWithChildren } from "react";

import { TwcOverlayTemplate } from "@/components/signup/layouts/product-overlay-template";

import { OnboardingContainerProps } from "../../../components";

export const TwcOnboardingContainer = ({
    header,
    subheader,
    children,
    size = "lg"
}: OnboardingContainerProps & PropsWithChildren) => (
    <TwcOverlayTemplate header={header} subheader={subheader} size={size}>
        {children}
    </TwcOverlayTemplate>
);
